import {useLocation} from 'react-router'
import React, {useEffect, useState} from 'react'
import {ModelePieceItemStock} from '../../../../../components/Models'
import {
  addPieceProp, checkDispoPiece,
  deletePieceInProposee,
  getCatdata,
  getOneVehicleHorsType,
  getOneVehicleModele,
  getPieceInStock,
} from '../../../../../components/requests'
import {ShopModal} from '../../Components/shop/ShopModal'
import {TooltipSpan} from '../../Components/Televendeur/TooltipSpan'
import {Link} from 'react-router-dom'
import {LoadingData} from '../../../../../components/LoadingData'
import SwitchToggle from '../../../../../components/SwitchToggle'
import moment from 'moment'
import Carousel from '../../../../../components/Carousel'
import {toast} from 'react-toastify'
import {usePanier} from './PanierContext'
import {Tooltip} from 'react-tooltip'
import ClientInfos from '../../Components/ClientInfos'
import CommentaireClientDemande from '../../../commentaireClientDemande/CommentaireClientDemande'
import {useAuth} from '../../../../modules/auth'

type LocationState = {
  piece: ModelePieceItemStock
  immat: string
  pieceId: number
  quantity: number
  nomTypePiece: string
  idTypePiece: number
  panier: any
  clientId: number
  demandeId: number
  demandeImmatId: number
  redirectToClientDemande: boolean
  refConst: string | null
  marque: string | null
  modele: string | null
  isViaModele: boolean
  isHorsType: boolean
  pieceQuantity: number
  idModele: number | null
  prixVentePropose: number
  montantRemise: number
  tauxRemise: number
  idPiecePropose: number
  dataClientInfos: any
  otherData: any
  loadingCLientInfo: boolean
  proposee: number
  pieces: any
  isProspect: boolean
  idDemandePiece: any
  immatriculationNonTrouvee: string | null
  infoVehiculePiece: any
  searchPage: any
  isFromPOT: boolean
  isFromClient: boolean
}

type DetailVehicle = {
  marque: string | undefined
  modele: string | undefined
  dateMiseCirc: string | undefined
}

const DetailsPiece = () => {
  const location = useLocation()
  const state = location.state as LocationState | undefined
  const [detailVehicle, setDetailVehicle] = useState<DetailVehicle>({
    marque: '',
    modele: '',
    dateMiseCirc: '',
  })
  const [pieceSelected, setPieceSelected] = useState<number | undefined>(state?.pieceId)
  const [piecesInStockArr, setPiecesInStockArr] = useState<any>([])
  const [piecesInStockArrTemp, setPiecesInStockArrTemp] = useState<any>([])
  const [price, setPrice] = useState<number>(0)
  const {panier, setPanier} = usePanier()
  const [loading, setLoading] = useState(true)
  const [isOn, setIsOn] = useState(true)
  const [quantity, setQuantity] = useState<number>(0)
  const [imagesArray, setImagesArray] = useState<any>([])
  const [piecesImages, setPiecesImages] = useState<any>([])
  const {currentUser} = useAuth()

  // pour récupérer les données immatriculation du vehicule (marque, modèle, date mise en circulation)
  const verifyCatdata = () => {
    if (state?.immat && state?.immat !== '') {
      const endPoint =
        state?.isViaModele || (state?.immat?.toString().includes('-') && !state?.isHorsType)
          ? getOneVehicleModele
          : state?.isHorsType
          ? getOneVehicleHorsType
          : getCatdata
      try {
        endPoint(state?.immat).then((res) => {
          if (res?.status === 200) {
            getQuantity()
            if (res?.data !== undefined) {
              setDetailVehicle({
                marque: state?.isViaModele
                  ? res?.data?.marque?.nom
                  : state?.isHorsType
                  ? res?.data?.marque
                  : res?.data?.smarque,
                modele: state?.isViaModele
                  ? res?.data?.nom
                  : state?.isHorsType
                  ? res?.data?.nom
                  : res.data.smodele,
                dateMiseCirc: state?.isViaModele || state?.isHorsType ? '' : res.data.sdatePme,
              })
            }
          }
        })
      } catch (ex) {
        console.error(ex)
      }
    }
  }

  const getQuantity = () => {
    const quantity = state?.pieceQuantity ?? 0
    setQuantity(quantity)
    getPiecesInStock()
  }

  // récupération des pièces en stock à afficher autres pièces
  const getPiecesInStock = () => {
    if (state?.pieceId) {
      try {
        getPieceInStock(
          state?.pieceId,
          state?.demandeId,
          state?.idTypePiece,
          state?.demandeImmatId,
          state?.clientId,
          state?.searchPage?.marque,
          state?.searchPage?.modele,
          state?.searchPage?.codeMoteur
        ).then((res) => {
          if (res?.data !== undefined && res?.status === 200 && res.data.length > 0) {
            setImagesArray(res.data)
            setPiecesInStockArr(res.data)
            setPiecesInStockArrTemp(
              res.data.map((item) => ({
                typePieceId: item?.piece_entre?.id,
                proposeeA: item?.proposeeA,
                proposeePar: item?.proposeePar,
              }))
            )
            setLoading(false)
          }
        })
      } catch (ex) {
        console.error(ex)
      }
    }
  }

  const handleChangePiece = (id, price) => {
    setPieceSelected(id)
    setPrice(price)
  }

  const addPieceProposee = async (demPieceId, pieceId, fraisPort, tauxRemise) => {
    const idToastCheckGroups = toast.loading('Ajout en cours...')
    try {
      const res = await addPieceProp(
        demPieceId,
        pieceId,
        state?.dataClientInfos?.id,
        currentUser?.id,
        null,
        state?.demandeId,
        ''
      )
      if (res && res?.status === 200 && res?.data !== undefined) {
        setPiecesInStockArr((prev) =>
          prev.map((p) =>
            p.piece_entre.id === pieceId
              ? {
                  ...p,
                  id: res?.data?.id,
                  proposeePar: res?.data?.proposeePar,
                  proposeeA: {
                    dateProposition: res?.data?.dateProposition,
                    nomClient: res?.data?.clientDemandePiece?.demande?.client?.nom,
                  },
                }
              : p
          )
        )
        toast.update(idToastCheckGroups, {
          render: 'Pièce ajoutée avec succès!',
          type: 'success',
          isLoading: false,
          autoClose: 2000,
        })
        return res?.data
      }
      return null
    } catch (ex) {
      console.error('Erreur:', ex)
    }
  }

  const removePieceProposee = async (demPieceId) => {
    try {
      const res = await deletePieceInProposee(demPieceId)
      setPiecesInStockArr((prev) =>
        prev.map((p) => {
          const pieceTempsValue = piecesInStockArrTemp.find(
            (item) => p?.piece_entre?.id === item?.typePieceId
          )
          return p.piece_entre.id === res?.data?.pieceEntre?.id
            ? {
                ...p,
                proposeePar: pieceTempsValue?.proposeePar ? pieceTempsValue?.proposeePar : null,
                proposeeA: pieceTempsValue?.proposeeA ? pieceTempsValue?.proposeeA : null,
              }
            : p
        })
      )
      return null
    } catch (ex) {
      console.error('Erreur:', ex)
    }
  }

  const handlePanier = async (piece, immat, idTypePiece, prixTransport, tauxRemise) => {
    let demPiece: any = null
    // Vérifie si la pièce est déjà présente dans le panier
    const isInPanier = panier.some((item) => item.id === piece.id)
    const idToastCheckPieces = toast.loading(
      `${!isInPanier ? 'Vérification' : 'Suppression'} en cours...`
    )

    // Vérifie si la pièce est dispo sur atemo ou non
    let isAvailable = {data: {Free: false}}
    // Si la pièce n'est pas dans le panier et dispo, on la propose
    if (!isInPanier) {
      let message
      let action
      try {
        isAvailable = await checkDispoPiece(piece.code)
        if (!isAvailable?.data?.Free) {
          message = 'Pièce disponible!'
          action = 'success'
          demPiece = await addPieceProposee(
            state?.idPiecePropose,
            piece.id,
            prixTransport ?? 0,
            tauxRemise ?? 0
          )
        } else {
          message = 'Pièce disponible!'
          action = 'success'
        }
      } catch (e) {
        console.error('Erreur')
        message = "Une erreur s'est produite lors de la vérification de la pièce"
        action = 'error'
      }
      toast.update(idToastCheckPieces, {
        render: message,
        type: action,
        isLoading: false,
        autoClose: 2000,
      })
      if (action === 'error') return;
    }

    setPanier((prevPanier) => {
      const exist = prevPanier.some((item) => item.id === piece.id)

      if (exist) {
        // Supprime l'objet s'il est déjà présent
        const arrPieProp = prevPanier.filter((item) => item.id === piece.id)
        if (arrPieProp) {
          removePieceProposee(arrPieProp[0]?.idPiecePropose)
          toast.update(idToastCheckPieces, {
            render: 'Pièce retirée du panier !',
            type: 'success',
            isLoading: false,
            autoClose: 2000,
          })
        }

        return prevPanier.filter((item) => item.id !== piece.id)
      } else {
        // Ajoute l'objet s'il n'est pas présent
        const codePiece =
          piece.piece.typePiece?.sousCategorie.categorie.code +
          piece.piece.typePiece?.sousCategorie.code +
          piece.piece.typePiece?.code

        let prixVenteProposee = piece.prix
        let montantRemise = 0
        let tr = 0

        if (tauxRemise) {
          tr = tauxRemise
          //montant de la remise recalculer
          montantRemise = (tr * piece.prix) / 100
          //prix de vente proposer recalculer
          prixVenteProposee = piece.prix - montantRemise
        }
        const now = new Date()
        const stockageDate = new Date(piece.stockageDate)

        // Pour eviter une décalage de date entre le front et le back
        now.setHours(0, 0, 0, 0)
        stockageDate.setHours(0, 0, 0, 0)

        const tempNbrJourStockageMs = stockageDate.getTime() - now.getTime()
        const diffDays = Math.abs(Math.floor(tempNbrJourStockageMs / (1000 * 60 * 60 * 24)))

        return [
          ...prevPanier,
          {
            id: piece.id,
            prix: piece.prix,
            refConstructeur: piece.piece.referenceConstructeur,
            statut: 'A_PROPO',
            etat: piece.etat.libelle,
            refCasier: piece.stockageBac || piece?.stockageAllee,
            marque: state?.marque,
            modele: state?.modele,
            marquePiece: piece.vehiculeEntre?.vehicule?.modele?.marque?.nom,
            modelePiece: piece.vehiculeEntre?.vehicule?.modele?.nom,
            nomTypePiece: piece.piece.typePiece.nom,
            idTypePiece: state?.idTypePiece ?? piece.piece.typePiece.id,
            immat:
              state?.isViaModele || state?.isHorsType
                ? detailVehicle.marque + ' - ' + detailVehicle.modele
                : state?.immat,
            demandeImmatId: state?.demandeImmatId,
            codePiece: codePiece,
            pieceQuantity: state?.pieceQuantity,
            prixVenteProposee: prixVenteProposee.toFixed(2),
            montantRemise: montantRemise,
            tauxRemise: tr.toFixed(2),
            fraisDePort: prixTransport,
            idPiecePropose: demPiece?.id,
            isProposed: demPiece?.isProposed,
            idCLientDemandePiece: demPiece?.clientDemandePiece?.id,
            immatriculationNonTrouvee: state?.immatriculationNonTrouvee ?? null,
            prixReferentiel: piece.prix,
            kilometrage: piece.vehiculeEntre?.km,
            affichageKilometrage: piece.piece?.typePiece?.affichageKilometrage ?? null,
            commentaires: piece.commentaire,
            nbrJourStockage: diffDays,
            dateStockage: piece.stockageDate,
            referencePiece: codePiece,
            datePremiereImmat: piece.vehiculeEntre.datePremiereImmat,
            prixConstructeur: piece.piece?.prixConstructeur,
            images: piece.images.map((item) => item.image),
            codePieceEntree: piece.code,
            isTypePiecePOT: false,
            isAccepted: demPiece?.isAccepted,
            isAcceptedBlocked: demPiece?.isAcceptedBlocked,
            isQuantityReached: false,
          },
        ]
      }
    })
  }

  useEffect(() => {
    verifyCatdata()
  }, [])

  useEffect(() => {
    setPieceSelected(piecesInStockArr[0]?.piece_entre?.id)
    setPrice(piecesInStockArr[0]?.piece_entre?.prix)
  }, [piecesInStockArr])

  // pour l'affichage des images correspondantes aux pièces sélectionnées
  useEffect(() => {
    const newArr = [...imagesArray]
    setPiecesImages(newArr.flat().filter((item) => item.piece_entre.id === pieceSelected))
  }, [pieceSelected])

  if (!state?.piece) return <p>Aucune donnée disponible</p>

  // Supprimer les "//" et mettre le texte en Abcdef
  const formatTexte = (str: string): string => {
    if (!str) return ''

    const result = str
      .replace(/\\r\\n|\r?\n|\\/g, ',') // retours ligne et backslashes → virgule
      .split(',') // découper sur virgule
      .map((s) => s.trim()) // enlever espaces
      .filter(Boolean) // supprimer morceaux vides
      .join(', ') // reconstruire avec virgule + espace

    return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase()
  }

  const renderRowPiece = () => {
    return (
      piecesInStockArr.length > 1 &&
      piecesInStockArr.map((piece) => {
        const isInPanier = panier.some((item) => item.id === piece?.piece_entre?.id) // Vérifie si la pièce est dans le panier
        return (
          <div
            key={piece.piece_entre?.id}
            className={`d-flex flex-row justify-content-between my-4 p-3 rounded cursor-pointer p-5 transition-colors duration-200
            ${pieceSelected === piece?.piece_entre?.id ? 'bg-gray-200' : 'hover:bg-gray-200'}`}
            onClick={() => {
              handleChangePiece(piece?.piece_entre?.id, piece?.piece_entre?.prix)
            }}
          >
            <div className='d-flex gap-5'>
              <img
                src={
                  piece?.images?.length > 0
                    ? `https://koena.fr/photos/pieces/${piece.images[0]}`
                    : 'https://placehold.co/100x100'
                }
                className='rounded'
                alt={piece?.piece_entre?.piece?.typePiece?.nom}
                width={100}
                height={100}
              />
              <div>
                <p className='fs-5 fw-bold text-gray-700'>
                  {piece?.piece_entre?.piece?.typePiece?.nom || 'Nom inconnu'}
                </p>
                <p className='bold text-gray-500'>
                  {piece?.piece_entre?.prix ? `${piece?.piece_entre?.prix} €` : 'Prix inconnu'}
                </p>
                {piece?.proposeeA && (
                  <p className='bold text-danger'>
                    Proposée
                    {piece.proposeeA?.nomClient && ` à ${piece.proposeeA?.nomClient}`}
                    {(piece?.proposeePar?.nom || piece?.proposeePar?.prenom) &&
                      ` par ${piece?.proposeePar?.nom ?? ''} ${piece?.proposeePar?.prenom ?? ''}`}
                    {piece.proposeeA?.dateProposition &&
                      ` le ${moment(piece.proposeeA?.dateProposition).format('DD/MM/YYYY')}`}
                  </p>
                )}
              </div>
            </div>
            <img
              src={
                isInPanier ? '/media/svg/custom/bag-minus.svg' : '/media/svg/custom/bag-plus.svg'
              }
              style={{
                cursor:
                  isInPanier && piece?.pieceProposee != '' && piece?.pieceProposee[0]?.isProposed
                    ? 'not-allowed'
                    : 'pointer',
                opacity:
                  isInPanier && piece?.pieceProposee != '' && piece?.pieceProposee[0]?.isProposed
                    ? 0.5
                    : 1,
              }}
              alt={isInPanier ? 'delete to shop' : 'add to shop'}
              width='40'
              onClick={(e) => {
                e.stopPropagation() // Empêche le `onClick` du parent de s'exécuter
                if (isInPanier && piece?.pieceProposee != '' && piece?.pieceProposee[0]?.isProposed)
                  return
                handlePanier(
                  piece?.piece_entre,
                  state?.isViaModele || state?.isHorsType
                    ? state?.marque + ' - ' + state?.modele
                    : state?.immat,
                  piece?.piece_entre?.piece?.typePiece?.id,
                  piece?.check_transport?.prix_transport,
                  piece?.check_transport?.tauxRemise
                ) // Appelle ta fonction `handlePanier`
              }}
            />
          </div>
        )
      })
    )
  }

  const renderPieceInStock = () => {
    const capitalizaFirstletter = (str: string = '') => {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    }
    return (
      piecesInStockArr.length > 0 &&
      piecesInStockArr
        .filter((piece) => piece?.piece_entre?.id == pieceSelected)
        .map((piece, index) => {
          return (
            <div key={index} className='mt-5' style={{lineHeight: '1'}}>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Réference constructeur</div>
                <div className='mb-5 fs-4 bold'>
                  {piece.piece_entre?.piece?.referenceConstructeur || ''}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Prix constructeur (HT)</div>
                <div className='mb-5 fs-4 bold'>
                  {piece.piece_entre?.piece?.prixConstructeur
                    ? `${piece.piece_entre?.piece?.prixConstructeur} €`
                    : ''}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Réference pièce</div>
                <div className='mb-5 fs-4 bold d-flex gap-2'>
                  <div>
                    {piece?.piece_entre?.piece?.typePiece?.sousCategorie.categorie.code}
                    {piece?.piece_entre?.piece?.typePiece?.sousCategorie.code}
                    {piece?.piece_entre?.piece?.typePiece?.code}
                    {piece?.piece_entre?.vehiculeEntre?.numero}
                  </div>
                  <a
                    href={`/vehicules/vehicules?numeroVehicule=${piece?.piece_entre?.vehiculeEntre?.numero}`}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i
                      className='bi bi-box-arrow-up-right cursor-pointer text-primary'
                      data-tooltip-id='tooltip'
                      data-tooltip-content='Voir la fiche du véhicule'
                      data-tooltip-place='right'
                    ></i>
                  </a>
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Marque véhicule</div>
                <div className='mb-5 fs-4 bold'>
                  {piece?.piece_entre?.vehiculeEntre?.vehicule?.modele?.marque?.nom || ''}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Modèle véhicule</div>
                <div className='mb-5 fs-4 bold'>
                  {piece?.piece_entre?.vehiculeEntre?.vehicule?.modele?.nom || ''}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Etat</div>
                <div className='mb-5 fs-4 bold'>
                  {capitalizaFirstletter(piece.piece_entre?.etat?.libelle) || ''}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Date mise en circulation</div>
                <div className='mb-5 fs-4 bold'>
                  {piece?.piece_entre?.vehiculeEntre?.datePremiereImmat == ''
                    ? ''
                    : moment(piece?.piece_entre?.vehiculeEntre?.datePremiereImmat).format(
                        'DD/MM/YYYY'
                      )}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Référence stockage</div>
                <div className='mb-5 fs-4 bold cursor-pointer'>
                  {piece.piece_entre?.stockageAllee && piece.piece_entre?.stockageBac ? (
                    <>
                      <TooltipSpan content={piece.piece_entre.stockageAllee} tooltip='Allee' />
                      {' / '}
                      <TooltipSpan content={piece.piece_entre.stockageBac} tooltip='Bac' />
                    </>
                  ) : piece.piece_entre?.stockageAllee ? (
                    <TooltipSpan content={piece.piece_entre.stockageAllee} tooltip='Allee' />
                  ) : piece.piece_entre?.stockageBac ? (
                    <TooltipSpan content={piece.piece_entre.stockageBac} tooltip='Bac' />
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className='d-flex justify-content-between gap-10'>
                <div className='mb-5 bold text-gray-600 fs-4'>Commentaire</div>
                <div
                  className='mb-5 fs-4 text-gray-700 text-end overflow-y-auto'
                  style={{
                    maxHeight: '150px',
                    maxWidth: '20vw',
                    lineHeight: 'normal',
                  }}
                >
                  {piece?.piece_entre?.commentaire == ''
                    ? 'Nc'
                    : formatTexte(piece?.piece_entre?.commentaire)}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Date de stockage</div>
                <div className='mb-5 fs-4 bold'>
                  {piece?.piece_entre?.stockageDate == ''
                    ? ''
                    : moment(piece?.piece_entre?.stockageDate).format('DD/MM/YYYY')}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Jour de stockage</div>
                <div className='mb-5 fs-4 bold'>{piece?.nbrJourStockage}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Kilométrage</div>
                <div className='mb-5 fs-4 bold'>
                  {piece?.piece_entre?.vehiculeEntre?.km != null
                    ? `${piece.piece_entre.vehiculeEntre.km} km`
                    : 'Nc'}
                </div>
              </div>
            </div>
          )
        })
    )
  }

  return (
    <>
      <ClientInfos
        clientData={state?.dataClientInfos}
        demandeId={state?.demandeId}
        otherData={state?.otherData}
        loadingCLientInfo={state?.loadingCLientInfo}
        isProspect={state?.dataClientInfos?.prospect}
        clientAdresses={null}
        contactedBy={null}
      />
      <div className='card p-9'>
        {loading ? (
          <LoadingData />
        ) : (
          <div className='row'>
            <div className='col-md-6 col-sm-12'>
              <div>
                <Link
                  to={`/demandes/${state?.demandeImmatId}/enStock/${state?.idTypePiece}`}
                  state={{
                    panier: panier,
                    quantity: state?.quantity,
                    immatriculation: state?.immat,
                    idModele: state?.idModele,
                    isViaModele: state?.isViaModele,
                    clientId: state?.clientId,
                    demandeId: state?.demandeId,
                    demandeImmatId: state?.demandeImmatId,
                    redirectToClientDemande: state?.redirectToClientDemande,
                    refConst: state?.refConst,
                    marque: state?.marque,
                    modele: state?.modele,
                    pieceQuantity: state?.pieceQuantity,
                    isHorsType: state?.isHorsType,
                    dataClientInfos: state?.dataClientInfos,
                    otherData: state?.otherData,
                    idPiecePropose: state?.idPiecePropose,
                    pieces: state?.pieces,
                    isProspect: state?.isProspect,
                    idDemandePiece: state?.idDemandePiece,
                    piece: state?.infoVehiculePiece,
                  }}
                  data-tooltip-id='tooltip'
                  data-tooltip-content='Revenir en arrière'
                  data-tooltip-place='right'
                >
                  <img
                    src='/media/svg/custom/prev-arrow.svg'
                    width={40}
                    className='mb-5'
                    alt='previous action'
                  />
                </Link>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='fs-2 bolder'>
                  {piecesInStockArr[0]?.piece_entre?.piece?.typePiece?.nom}
                </div>
              </div>
              <div className='mb-6 mt-8'>
                <Carousel
                  imagesArray={piecesImages[0]?.images ?? []}
                  loading={loading}
                  nomPiece={piecesInStockArr[0]?.piece_entre?.piece?.typePiece?.nom}
                  taille={'600x400'}
                />
              </div>
              <div>
                <div className='d-flex justify-content-between'>
                  <p className=''>{piecesInStockArr.length} en stock</p>
                  {piecesInStockArr.length == 1 && piecesInStockArr[0]?.proposeeA && (
                    <p className='text-danger'>
                      Proposée
                      {piecesInStockArr[0]?.proposeeA?.nomClient &&
                        ` à ${piecesInStockArr[0]?.proposeeA?.nomClient}`}
                      {(piecesInStockArr[0]?.proposeePar?.nom ||
                        piecesInStockArr[0]?.proposeePar?.prenom) &&
                        ` par ${piecesInStockArr[0]?.proposeePar?.nom ?? ''} ${
                          piecesInStockArr[0]?.proposeePar?.prenom ?? ''
                        }`}
                      {piecesInStockArr[0]?.proposeeA?.dateProposition &&
                        ` le ${moment(piecesInStockArr[0]?.proposeeA?.dateProposition).format(
                          'DD/MM/YYYY'
                        )}`}
                    </p>
                  )}
                </div>
                <div className='d-flex flex-row-reverse justify-content-between align-items-center'>
                  <div className='fs-2 mb-4 mt-4 text-end'>{price} €</div>
                </div>
              </div>
              <div className='d-flex mb-7 mt-7 gap-2'>
                <SwitchToggle checked={isOn} onChange={setIsOn} />
                <div>Envoyer un email au client</div>
              </div>
              <div className='d-flex justify-content-between'>
                <button
                  type='button'
                  className={
                    panier.some((item) => item.id === pieceSelected)
                      ? 'btn btn-danger'
                      : 'btn btn-primary'
                  }
                  onClick={() => {
                    const piece = piecesInStockArr.find((p) => p.piece_entre?.id === pieceSelected)
                    if (piece)
                      handlePanier(
                        piece.piece_entre,
                        state?.isViaModele || state?.isHorsType
                          ? state?.marque + ' - ' + state?.modele
                          : state?.immat,
                        piecesInStockArr[0]?.piece_entre?.piece?.typePiece?.id,
                        piece?.check_transport?.prix_transport,
                        piece?.check_transport?.tauxRemise
                      )
                  }}
                  disabled={panier.some(
                    (item) => item.id === pieceSelected && item.statut != 'A_PROPO'
                  )}
                >
                  {panier.some((item) => item.id === pieceSelected)
                    ? 'Retirer du panier'
                    : 'Ajouter au panier'}
                </button>
                <ShopModal
                  clientId={state?.clientId}
                  demandeId={state?.demandeId}
                  panier={panier}
                  setPanier={setPanier}
                  piecesInStockArr={piecesInStockArr}
                  setPiecesInStockArr={setPiecesInStockArr}
                  piecesInStockArrTemp={piecesInStockArrTemp}
                  redirectToClientDemande={state?.redirectToClientDemande}
                  pieceQuantity={state?.pieceQuantity}
                  idPiecePropose={state?.idPiecePropose}
                  pieces={state?.pieces}
                  dataClientInfos={state?.dataClientInfos}
                  otherData={state?.otherData}
                  loadingCLientInfo={state?.loadingCLientInfo}
                  isProspect={state?.isProspect}
                  totalPanier={panier.length}
                />
              </div>
            </div>
            <div className='col-md-6 col-sm-12'>
              <h2 style={{marginTop: '30px'}}>Information du produit</h2>
              {renderPieceInStock()}
              {piecesInStockArr.length > 1 && (
                <>
                  <hr />
                  <h2 style={{marginTop: '30px'}}>Autres pièces en stock</h2>
                  <div className='card-scroll h-400px'>{renderRowPiece()}</div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      {/*Affichage tooltip*/}
      <CommentaireClientDemande idClientDemande={state?.demandeId} clientId={state?.clientId}/>
      <Tooltip id='tooltip' />
    </>
  )
}

export {DetailsPiece}
